import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetPackListForModalController::__invoke
* @see app/Http/Controllers/Item/GetPackListForModalController.php
* @route '/api/pack-for-modal'
*/
const GetPackListForModalController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackListForModalController.url(options),
    method: 'get',
})

GetPackListForModalController.definition = {
    methods: ["get","head"],
    url: '/api/pack-for-modal',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetPackListForModalController::__invoke
* @see app/Http/Controllers/Item/GetPackListForModalController.php
* @route '/api/pack-for-modal'
*/
GetPackListForModalController.url = (options?: RouteQueryOptions) => {
    return GetPackListForModalController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetPackListForModalController::__invoke
* @see app/Http/Controllers/Item/GetPackListForModalController.php
* @route '/api/pack-for-modal'
*/
GetPackListForModalController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackListForModalController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetPackListForModalController::__invoke
* @see app/Http/Controllers/Item/GetPackListForModalController.php
* @route '/api/pack-for-modal'
*/
GetPackListForModalController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPackListForModalController.url(options),
    method: 'head',
})

export default GetPackListForModalController